export class SuperAdministratorModel {
    public id :string;
    public firstName : string='';
    public lastName : string='';
    public roleName : string;
    public profilePictureUrl : string;
    public email : string='';
    public phone : string='';
    public dateOfBirth :any;
   
}